import React from 'react';
import { Label, LabelProps } from '../Label';
import { UdsFC } from '../../../types';
import { useAppFormControlContext } from './appFormControlContext';
import { appFormDataTestFactory } from './appFormDataTestFactory';

export const AppFormLabel: UdsFC<LabelProps> = (props) => {
  const context = useAppFormControlContext();
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  return (
    <Label
      {...props}
      htmlFor={props.htmlFor ?? (context.name ? `${context.name}-input` : undefined)}
      required={props.required ?? context.required}
      error={'error' in props ? props.error : !!context.error}
      dataTest={appFormDataTestFactory(props.dataTest ?? context.dataTest).label}
      shrink
    />
  );
};
